<template>
  <!--带Label输入框-->
  <div class="weui-cell" v-if="haveLabel">
    <div class="weui-cell__hd">
      <label class="weui-label">
        {{title}}
      </label>
    </div>
    <div class="weui-cell__bd">
      <input class="weui-input text-right" :class="{'pr-15': clearIcon}" :type="inputType" :placeholder="inputPlaceholder"
      :value="value" @input="inputEvent">
      <span id="deleteIcon" @mousedown="clean($event)"><i class="s-icon-times-circle" v-if="showClean"></i></span>
    </div>
    <div class="weui-cell__ft">
      <slot name="foot"></slot>
    </div>
  </div>
  <!--无Label输入框-->
  <div class="weui-cell" v-else>
    <div class="weui-cell__hd">
      <input class="weui-input" :type="inputType" :placeholder="inputPlaceholder"
             :value="value" @input="inputEvent">
    </div>
    <div class="weui-cell__bd">
    </div>
    <div class="weui-cell__ft">
      <i class="s-icon-cancel" @click="cancelText()"></i>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    name: 'c-cell-input',
    props: {
      title: {
        type: String,
        default: ''
      },
      inputPlaceholder: {
        type: String,
        default: ''
      },
      inputType: {
        type: String,
        default: 'text'
      },
      value: {
        type: String,
        default: ''
      },
      clearIcon: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        haveLabel: true,
        showClearIcon: true
      }
    },
    components: {},
    created () {
    },
    mounted () {
      this.haveLabel = this.title !== '' // title是否为空
    },
    beforeDestroy () {
    },
    methods: {
      inputEvent (event) {
        this.$emit('input', event.target.value)
      },
      clean (event) {
        event.preventDefault()
        this.$emit('input', '')
      }
    },
    computed: {
      showClean () {
        return this.clearIcon && this.value && this.value.length > 0
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?5dd96836